function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Sun"
}, React.createElement("circle", {
  cx: 32,
  cy: 32,
  fill: "#ffda44",
  r: 15
}), React.createElement("g", {
  fill: "#ff5023"
}, React.createElement("path", {
  d: "m32 2-3 6h3z"
}), React.createElement("path", {
  d: "m35 8h-3v6z"
}), React.createElement("path", {
  d: "m46.849 12.908 2.122 2.121 4.242-4.242z"
}), React.createElement("path", {
  d: "m51.092 17.151-2.121-2.122-4.243 4.243z"
}), React.createElement("path", {
  d: "m56 29v3h6z"
}), React.createElement("path", {
  d: "m56 35v-3h-6z"
}), React.createElement("path", {
  d: "m48.971 48.971 4.242 4.242-2.121-6.364z"
}), React.createElement("path", {
  d: "m46.849 51.092 2.122-2.121-4.243-4.243z"
}), React.createElement("path", {
  d: "m32 62 3-6h-3z"
}), React.createElement("path", {
  d: "m29 56h3v-6z"
}), React.createElement("path", {
  d: "m17.151 51.092-2.122-2.121-4.242 4.242z"
}), React.createElement("path", {
  d: "m12.908 46.849 2.121 2.122 4.243-4.243z"
}), React.createElement("path", {
  d: "m8 35v-3h-6z"
}), React.createElement("path", {
  d: "m8 29v3h6z"
}), React.createElement("path", {
  d: "m15.029 15.029-4.242-4.242 2.121 6.364z"
}), React.createElement("path", {
  d: "m17.151 12.908-2.122 2.121 4.243 4.243z"
})), React.createElement("path", {
  d: "m20 32h2a10.011 10.011 0 0 1 10-10v-2a12.013 12.013 0 0 0 -12 12z",
  fill: "#ff9811"
}));

var SvgSun = function SvgSun(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSun, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sun.bf4e9d45.svg";
export { ForwardRef as ReactComponent };